const routerArr = [{
        path: "/rensheMyProfile",
        name: "rensheMyProfile",
        meta: {
            title: "我的资料",
            login: true
        },
        component: () => import( /* webpackChunkName: 'rensheDistribution' */ './account/userInfo.vue')
    },
    {
        path: "/myAdmissionTicket",
        name: "myAdmissionTicket",
        meta: {
            title: "我的准考证",
            login: true
        },
        component: () => import( /* webpackChunkName: 'rensheDistribution' */ './account/myAdmissionTicket.vue')
    },
    {
        path: "/myGrades",
        name: "myGrades",
        meta: {
            title: "我的成绩",
            login: true
        },
        component: () => import( /* webpackChunkName: 'rensheDistribution' */ './account/myGrades.vue')
    },
    {
        path: "/gradeDetail",
        name: "gradeDetail",
        meta: {
            title: "我的成绩",
            login: true
        },
        component: () => import( /* webpackChunkName: 'rensheDistribution' */ './account/gradeDetail.vue')
    },
    {
        path: "/finishExamAuth",
        name: "finishExamAuth",
        meta: {
            title: "考试认证",
            login: true
        },
        component: () => import( /* webpackChunkName: 'rensheDistribution' */ './account/finishExamAuth.vue')
    },
    {
        path: '/institutionsIn',
        name: 'institutionsIn',
        meta: {
            title: '入驻申请',
            login: false,
        },
        component: () => import( /* webpackChunkName: 'institutionsIn' */ './institutionsIn/page/institutionsIn.vue')
    },
    {
        path: '/finishApply',
        name: 'finishApply',
        meta: {
            title: '入驻申请',
            login: false,
        },
        component: () => import( /* webpackChunkName: 'institutionsIn' */ './institutionsIn/page/finishApply.vue')
    }


]

export default routerArr